import type { FC } from "react";

import { Label } from "@/shared/ui/label";
import { Button } from "@/shared/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { BlurredInfo } from "@/shared/ui/BlurredInfo";
import { MeResponse, useMe } from "@/entities/profile";

interface NotificationSettingsProps {
  notificationType: "telegram" | "panel";
  setNotificationType: (type: "telegram" | "panel") => void;
  userData?: MeResponse;
}

export const NotificationSettings: FC<NotificationSettingsProps> = ({
  notificationType,
  setNotificationType,
}) => {
  const { data, isPending, isSuccess } = useMe();

  return (
    <div className="flex gap-2">
      <div className="flex flex-1 flex-col gap-2">
        <Label className="font-semibold text-textColor max-md:text-xs">
          Получение уведомлений
        </Label>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button className="h-10 w-full text-textColor" variant={"outline"}>
              {notificationType === "telegram" ? "В бота" : "В панель"}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem
              onClick={() => {
                setNotificationType("panel");
              }}
            >
              В панель
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                setNotificationType("telegram");
              }}
            >
              В бота
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="flex flex-1 flex-col gap-2">
        <Label className="font-semibold text-textColor max-md:text-xs">
          Привязка Telegram
        </Label>
        <BlurredInfo
          value={data?.tgCode ?? ""}
          isPending={isPending}
          isSuccess={isSuccess}
          height={10}
          placeholder="M3zjva4z"
        />
      </div>
    </div>
  );
};
